import { Notification } from '@teko/notification';
import { getTrackingData } from '@teko/tracking';
import { NotificationItem } from './NotificationItem';
export const NotificationList = ({
  notifications,
  onNotificationClick,
}: {
  notifications: Notification[];
  onNotificationClick: (notification: Notification) => Promise<void>;
}) => {
  return (
    <>
      {notifications.map((notification: Notification) => (
        <NotificationItem
          key={notification.id}
          title={notification.title}
          message={notification.message}
          isRead={notification.is_read}
          onClick={() => onNotificationClick(notification)}
          time={notification.created_at}
          avatar={
            !notification.order
              ? notification.image_url
              : notification.order.imageUrl
          }
          {...getTrackingData({
            isTrackContent: true,
            contentName: 'notification',
            regionName: 'notificationList',
            index: notification.id,
            payload: JSON.stringify({
              msg_id: notification.id.toString(),
              trace_id: notification.trace_id,
            }),
          })}
        />
      ))}
    </>
  );
};
